import gql from "graphql-tag";

export const GET_CATEGORIES = gql`
  query {
    categories {
      id
      name
      type
    }
  }
`;

export const ADD_CATEGORY = gql`
  mutation AddCategory($name: String!, $type: String) {
    addCategory(name: $name, type: $type) {
      id
      name
      type
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory($id: ID!, $name: String!, $type: String) {
    updateCategory(id: $id, name: $name, type: $type) {
      id
      name
      type
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($id: ID!) {
    deleteCategory(id: $id)
  }
`;
